var _jsxFileName = "/codebuild/output/src2464868119/src/bitbucket.org/newyuinc/adc-polaris-web/src/components/consents/VerifyConsents.tsx";
import React, { useCallback, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { LoadingModal } from '@adc/parallax-component-library';
import { APP_RETURN_TIMEOUT } from 'Constants';
import jwtDecode from 'jwt-decode';
import { MainContainer } from 'Components/utility';
import { AUTH_SESSION } from 'Reducers/auth/types';
import { notifyApp } from 'Utilities/appCommunicator';
import log from 'Utilities/log';
import mediator from 'Utilities/mediator';
import { persistAuthSession } from 'Utilities/session';
import { store } from 'Utilities/store';
import { getPatient } from 'Services/patient';
const mapStateToProps = ({
  nav: {
    query: {
      token,
      osType,
      osVersion,
      app,
      appVersion
    }
  }
}) => {
  return {
    token,
    osType,
    osVersion,
    app,
    appVersion
  };
};
const connector = connect(mapStateToProps);
const VerifyConsents = ({
  token,
  osType,
  osVersion,
  app,
  appVersion
}) => {
  const [loading, setLoading] = useState(false);
  const handleError = useCallback(error => {
    notifyApp('adc-webview:navigation', error);

    // Give the app time to redirect the user back
    setTimeout(() => {
      setLoading(false);
    }, APP_RETURN_TIMEOUT);
  }, []);
  const verifyConsents = useCallback(token => {
    setLoading(true);
    const decodedToken = jwtDecode(token);
    getPatient(decodedToken.id, osType, osVersion, app, appVersion, token).then(patient => {
      var _patient$consents;
      // Store the user session
      const authSession = {
        access_token: token,
        account_id: decodedToken.id,
        expires: decodedToken.exp,
        include: {
          patient
        }
      };
      persistAuthSession({
        access_token: authSession.access_token,
        account_id: authSession.account_id,
        expires: authSession.expires
      });
      store.dispatch({
        type: AUTH_SESSION,
        authSession
      });
      const {
        country,
        consents
      } = patient;
      const isUS = country === 'US';
      const hasOutdatedHealthConsent = isUS ? Object.hasOwn(consents, 'hipaa') && !consents.hipaa.at : Object.hasOwn(consents, 'crm') && !consents.crm.at;
      if (hasOutdatedHealthConsent) {
        mediator.publish('router:navigate', '/hipaa');
        return;
      }
      if (!((_patient$consents = patient.consents) !== null && _patient$consents !== void 0 && (_patient$consents = _patient$consents.realWorldEvidence) !== null && _patient$consents !== void 0 && _patient$consents.at)) {
        mediator.publish('router:navigate', '/rwe');
        return;
      }
      handleError();
    }).catch(error => {
      log.error('Failed to load the consents', error);
      handleError(error);
    });
  }, [app, appVersion, handleError, osType, osVersion]);
  useEffect(() => {
    if (token) {
      verifyConsents(token);
    }
  }, [token, verifyConsents]);
  return /*#__PURE__*/React.createElement(MainContainer, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 10
    }
  }, loading && /*#__PURE__*/React.createElement(LoadingModal, {
    "aria-label": "Loading",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 113,
      columnNumber: 37
    }
  }));
};
export default connector(VerifyConsents);